import { RouteConfig } from 'vue-router'
import { GlobalConfigRouteMetaEnum } from 'kuaidong-model'
const LayoutEmpty = () => import('../views/LayoutEmpty.vue')

const CompetitionManagementPage = () => import('@/views/CompetitionManagement.vue')
const CompetitionManagementDetailPage = () => import('@/views/CompetitionManagementDetailsInfo.vue')
const CompetitionManagementDetailStatePage = () => import('@/views/CompetitionManagementDetailsStats.vue')

export const managementRoute: RouteConfig = {
  path: 'management',
  name: 'competition_management',
  component: CompetitionManagementPage,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '管理比赛',
    showMenu: true,
  },
}
export const managementDetailsRoute: RouteConfig = {
  path: 'management-details',
  name: 'competition_management_details',
  component: CompetitionManagementDetailPage,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '管理比赛',
    showMenu: false,
    [GlobalConfigRouteMetaEnum.All]: true,
  },
}

export const managementDetailStateRoute: RouteConfig = {
  path: 'management-details-stat',
  name: 'competition_management_details_stat',
  component: CompetitionManagementDetailStatePage,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '管理比赛',
    showMenu: false,
  },
}

export default [
  {
    path: '/competition-management',
    name: 'competition_management',
    component: LayoutEmpty,
    redirect: managementRoute.name,
    children: [managementRoute, managementDetailsRoute, managementDetailStateRoute],
  },
]
